var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRatingHighPerformer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21",
    style: {
      enableBackground: "new 0 0 21 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FAD980;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#222222;stroke-width:0.8085;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#323232;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "high-performing plan icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "high-performing-plan-icon"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    className: "st0",
    points: "10.5,1 20,18 1,18  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "fa-star",
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-275",
    className: "st1",
    d: "M0.3,6.3l3.5,3.3l-0.8,4.7c0,0.1,0,0.2,0,0.2c0,0.1,0,0.3,0.1,0.3C3.1,14.9,3.2,15,3.3,15 c0.1,0,0.3,0,0.4-0.1L8,12.6l4.3,2.2c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.1,0-0.2 l-0.8-4.7l3.5-3.3c0.2-0.2,0.3-0.3,0.3-0.5c0-0.2-0.2-0.4-0.5-0.4l-4.8-0.7L8.5,0.4C8.3,0.2,8.2,0.1,8,0.1c-0.2,0-0.3,0.1-0.5,0.4 L5.4,4.7L0.6,5.4C0.2,5.5,0.1,5.6,0.1,5.8C0.1,6,0.1,6.1,0.3,6.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M9.4,14.9c-0.3-0.1-0.5-0.3-0.7-0.6c-0.2-0.2-0.2-0.5-0.3-0.8v0c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0h0.7 c0.1,0,0.2,0.1,0.2,0.2c0.1,0.2,0.2,0.4,0.4,0.5s0.4,0.2,0.6,0.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7 c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3c-0.2,0-0.3,0-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.2c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0.1 c0,0-0.1,0-0.1,0H8.8c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1l0.3-2.6c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1H12c0.1,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1v0.5c0,0.1,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1H9.8l-0.1,1.2c0.1-0.1,0.3-0.1,0.4-0.2s0.4-0.1,0.6-0.1 c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.7,0.6s0.3,0.6,0.3,0.9c0,0.4-0.1,0.7-0.3,1s-0.4,0.5-0.7,0.6c-0.3,0.2-0.7,0.2-1.1,0.2 C10,15.1,9.7,15,9.4,14.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatingHighPerformer);
export default __webpack_public_path__ + "static/media/star-rating-high-performer.c12754106e292a6a147ca396396d036a.svg";
export { ForwardRef as ReactComponent };